import {extendTheme} from '@chakra-ui/react'


const theme = extendTheme({
    initialColorMode : 'light',
    useSystemColorMode : true
})

export default theme;